import data from "./data.json";

const TermsAndConditions = () => {
  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Centered Page Title */}
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <h1 style={{ 
          fontSize: '18px', 
          fontWeight: 'bold', 
          color: '#003883',
          margin: '0 0 10px 0'
        }}>
          {data.pageTitle}
        </h1>
        <div style={{ 
          width: '80px', 
          height: '3px', 
          backgroundColor: '#003883', 
          margin: '0 auto' 
        }}></div>
      </div>

      {/* Single Card Layout for All Sections */}
      <div style={{
        backgroundColor: '#f8f9fa',
        padding: '30px',
        borderRadius: '8px',
        border: '1px solid #e9ecef',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        textAlign: 'justify'
      }}>
        {data.sections.map((section) => (
          <div key={section.id} style={{
            marginBottom: '30px'
          }}>
            <h2 style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#003883',
              marginBottom: '20px',
              borderBottom: '2px solid #003883',
              paddingBottom: '10px'
            }}>
              {section.id}. {section.title}
            </h2>

            {section.clauses && section.clauses.length > 0 ? 
              section.clauses.map((clause) => (
                <p key={clause.id} style={{
                  marginBottom: '15px',
                  lineHeight: '1.6',
                  color: '#495057',
                  fontSize: '14px'
                }}>
                  <strong style={{ 
                    color: '#003883',
                    fontWeight: '600',
                    marginRight: '8px'
                  }}>
                    {clause.id}
                  </strong> 
                  {clause.text}
                </p>
              ))
              :
              section.details && section.details.length > 0 &&
              section.details.map((detail, index) => (
                <p key={index} style={{
                  marginBottom: '15px',
                  lineHeight: '1.6',
                  color: '#495057',
                  fontSize: '14px'
                }}>
                  {detail}
                </p>
              ))
            }
          </div>
        ))}
      </div>
    </div>
  );
}

export default TermsAndConditions;